import React from "react";
import IconButton from "../../CommonComponents/IconButton";
import InputField from "../../CommonComponents/InputField";

const QnCountField = ({
  className = "",
  id,
  value,
  name,
  onChange,
  onClick,
  placeholder = "00",
  hintText = "",
  destructive = false,
  disabled = false,
}) => {
  return (
    <div
      className={`config-qns-score-count-field${
        hintText ? " qns-score-count-hint-text" : ""
      } ${className}`}
      key={id}
    >
      <IconButton
        hierarchy="secondaryGrey"
        onClick={() => onClick(parseInt(value || 0) - 1)}
        disabled={!value || +value === 0 || disabled}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.91675 7H11.0834"
            stroke="#344054"
            strokeWidth="1.169"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconButton>
      <InputField
        placeholder={placeholder}
        className="config-qns-count-input"
        name={name}
        type="number"
        destructive={destructive}
        value={value}
        onChange={onChange}
        disabled={disabled}
        hintText={hintText}
      />
      <IconButton
        hierarchy="secondaryGrey"
        onClick={() => onClick(parseInt(value || 0) + 1)}
        disabled={disabled}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.00008 2.91663V11.0833M2.91675 6.99996H11.0834"
            stroke="#344054"
            strokeWidth="1.169"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconButton>
    </div>
  );
};

export default QnCountField;
